<dx-data-grid biz-grid [selection]='{ mode: "multiple" }' [dataSource]='items()' [bizSetSummary]="false" stateStorageKey="monitorItems" (onRowRemoving)="onRowRemoving($event)"
    (bizOnToolbarPreparing)="onToolbarPreparing($event)" (onRowDblClick)="onRowDblClick($event)" (onSelectionChanged)='selectionChanged($event)'>

    <dxo-editing [allowUpdating]="allowUpdating()" [allowAdding]="allowAdding()" [allowDeleting]="allowDeleting()">
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="monitorGroupId" caption="Group" dataType="string" sortOrder="asc" cellTemplate="monitorGroup" [calculateSortValue]="calculateSortValueForGroup">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxo-lookup [dataSource]="groups()" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>
    <div *dxTemplate="let cellInfo of 'monitorGroup'">
        <a [routerLink]="'/monitor/groups/'">{{cellInfo.text}}</a>
    </div>

    <dxi-column dataField="name" dataType="string" sortOrder="asc">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="description" dataType="string">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="artifactId" caption="Type" dataType="string" [calculateDisplayValue]="getArtifactType">
    </dxi-column>

    <dxi-column dataField="enabled" dataType="boolean">
    </dxi-column>

    <dxi-column caption="Paused" dataType="string" cellTemplate="absenceNote" alignment="center">
    </dxi-column>
    <div *dxTemplate="let cellInfo of 'absenceNote'">
        @if (cellInfo.data.absenceItemTemplate !== null) {
            <app-status-traffic-light [status]="'Pause'" [tooltip]="$safeNavigationMigration(cellInfo.data.absenceItemTemplate?.Note)"></app-status-traffic-light>
        }
    </div>

    <dxi-column dataField="currentStatus" caption="Last status" dataType="string" cellTemplate="statusTemplate" alignment="center" [calculateSortValue]="calculateSortValueForStatus"
        [calculateFilterExpression]="calculateStatusFilterExpression">
        <dxo-header-filter [dataSource]="getStatusHeaderFilterData()"></dxo-header-filter>
        <div *dxTemplate="let data of 'statusTemplate'">
            <app-status-traffic-light [status]="$safeNavigationMigration(data.value?.EffectiveStatus)"></app-status-traffic-light>
        </div>
    </dxi-column>

    <dxi-column caption="Last status time" dataType="string" [calculateDisplayValue]="getStatusTimestamp" alignment="center">
    </dxi-column>

    <dxi-column dataField="pollingInterval" dataType="number" alignment="center">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="stakeholderId" caption="Stakeholder" dataType="string" cellTemplate="stakeholder" [visible]="false">
        <dxo-lookup [dataSource]="stakeholdersAndNull()" valueExpr="StakeholdersId" displayExpr="Name"></dxo-lookup>
    </dxi-column>
    <div *dxTemplate="let cellInfo of 'stakeholder'" [calculateSortValue]="calculateSortValueForStakeholder">
        <a [routerLink]="'/error/stakeholder/'">{{cellInfo.value ? cellInfo.text : ''}}</a>
    </div>

    <dxi-column dataField="stakeholderUrgent" caption="Is urgent" dataType="boolean" [visible]="false">
    </dxi-column>

    <dxi-column dataField="stakeholderContinuous" caption="Continuous notification" dataType="boolean" [visible]="false">
    </dxi-column>

    <dxi-column dataField="scheduleId" caption="Schedule" dataType="string" cellTemplate="schedule" [visible]="false">
        <dxo-lookup [dataSource]="schedulesAndNull()" valueExpr="Id" displayExpr="Name"></dxo-lookup>
    </dxi-column>
    <div *dxTemplate="let cellInfo of 'schedule'">
        <a [routerLink]="'/monitor/schedule/'">{{cellInfo.value ? cellInfo.text : ''}}</a>
    </div>

    <dxi-column dataField="suppressToStatus" caption="Suppress errors to" dataType="string" [visible]="false">
        <dxo-lookup [dataSource]="suppressToStatuses" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="suppressMessagesCount" caption="Suppress count" dataType="number" alignment="center" [visible]="false" [customizeText]="customizeTextSuppressMessagesCount">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(items(), 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>

    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>

    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(items(), 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>

    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="edit" text="Details" [onClick]="editItem"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog()"></dxi-button>
        <ng-container *dxTemplate="let cell of 'logTemplate'">
            <app-change-log-link [title]="'Log for ' + cell.data.name" [showIcon]="false" classNames="dx-link">
                <app-change-log-link-entity type="MonitorItem" [id]="cell.data.id"></app-change-log-link-entity>
            </app-change-log-link>
        </ng-container>
    </dxi-column>
</dx-data-grid>
